module.exports = __webpack_public_path__ + "img/Blog.33003d1d.png";